export default __webpack_public_path__ + "static/media/fb-taraftart-card-gray-with-bg.d720cc91.png";